import {Directive, Input} from '@angular/core';
import {CustomValidationService} from '../services/custom-validation.service';
import {AbstractControl, NG_VALIDATORS} from '@angular/forms';

@Directive({
  selector: '[barcodeMinimumAmount]',
  providers: [{ provide: NG_VALIDATORS, useExisting: BarcodeMinimumAmountDirective, multi: true }]
})
export class BarcodeMinimumAmountDirective {
  @Input('barcodeMinimumAmount') barcodeMin: number;
  constructor(private customValidator: CustomValidationService) { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.customValidator.barcodeMinimumAmountValidator(this.barcodeMin)(control);
  }

}